import * as requestFromServer from "./walletCrud";
import { WalletHistorySlice, setLoading } from "./walletSlice";

const { actions: walletActions } = WalletHistorySlice;
export const fetchWalletHistory =
  (
    actionType,
    searchTerm = "",
    currentPage = "",
    sortBy = "",
    sortDir = "asc"
  ) =>
  (dispatch) => {
    dispatch(setLoading(true));

    let fetchFunction = requestFromServer.callFetchWalletHistory;

    return fetchFunction(actionType, searchTerm, currentPage, sortBy, sortDir)
      .then((response) => {
        if (response.data.status) {
          dispatch(
            walletActions.setWalletHistoryData({
              data: response.data.data,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(walletActions.catchError(error));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
